import type { RailBranch } from "../../data/rail-branches";
import { branchOffsetY } from "../timeline/rail/RailBranchMotion/motion";
import { railWorldX, SCENE_MARK_HALF_LEN, type SceneStart } from "./scene-marks";

/** The scene start whose tick is nearest a world point, if one is within reach. */
export function tickNear(
  sceneStarts: readonly SceneStart[],
  branches: readonly RailBranch[],
  axisY: number,
  viewportWidth: number,
  point: { x: number; y: number },
  reach: number,
): number | undefined {
  let best: { startMs: number; distance: number } | undefined;
  for (const start of sceneStarts) {
    const x = railWorldX(start.startMs, viewportWidth);
    if (Math.abs(x - point.x) > reach) {
      continue;
    }
    const ys = branches.length === 0
      ? [axisY]
      : branches
        .filter((item) => start.startMs >= item.startMs && start.startMs < item.endMs)
        .map((item) => axisY + branchOffsetY(item, start.startMs));
    for (const y of ys) {
      // The tick is a short upright line, so anywhere along it counts.
      const dy = Math.max(0, Math.abs(y - point.y) - SCENE_MARK_HALF_LEN);
      const distance = Math.hypot(x - point.x, dy);
      if (distance <= reach && (best === undefined || distance < best.distance)) {
        best = { startMs: start.startMs, distance };
      }
    }
  }
  return best?.startMs;
}
